interface SalesStage {
  id: number;
  salesStage: string;
}

export const salesStages: SalesStage[] = [
  { id: -1, salesStage: 'Select Customer Status' },
  { id: 0, salesStage: 'Not Set' },
  { id: 1, salesStage: 'Prospect' },
  { id: 2, salesStage: 'Active' },
  { id: 3, salesStage: 'In-Active' },
  { id: 4, salesStage: 'Lost' },
];
